import {createSlice, current} from "@reduxjs/toolkit";
import type {PayloadAction} from "@reduxjs/toolkit";
import {FormStep, FormData, FormState} from "@/lib/types/upgrad/upgradCoSignerForm"

const formStep: FormStep = {
    currentStep: 2,
    steps: [
        {
            title: 'Xác thực định danh',
            time: '5 phút',
            fields: []
        },
        {
            title: 'Xác thực định danh',
            time: '5 phút',
            fields: []
        },
        {
            title: 'Xác thực định danh',
            time: '5 phút',
            fields: []
        },
        {
            title: 'Thông tin hồ sơ',
            time: '3 phút',
            fields: ['bankAccount', 'houseBook', 'laborContract', 'marriageRegistration', 'vssid']
        }
    ]
}

const formData: FormData = {
    step2: {
        face: {
            image: "",
            status: "idle",
            message: "Chụp ảnh chân dung của bạn",
        },
        idFront: {
            image: "",
            status: "disabled",
            message: "Chụp ảnh mặt trước của CCCD",
        },
        idBack: {
            image: "",
            status: "disabled",
            message: "Chụp ảnh mặt sau của CCCD",
        },
        faceMatching: {
            status: 'disabled',
            message: '',
            idData: {}
        }
    },
    step4: {
        houseBook: "",
        vssid: "",
        bankAccount: "",
        laborContract: "",
        marriageRegistration: ""
    }
};

const initialState: FormState = {
    formStep: formStep,
    formData: formData,
    initalData: {
        applicationId: ''
    }
};

export const upgradCoSignerFormSlice = createSlice({
    name: "upgradCoSignerForm",
    initialState,
    reducers: {
        setInititalData: (state, actions: PayloadAction<any>) => {
            state.initalData = actions.payload;
        },
        updateFormData: (state, actions: PayloadAction<{ step: number, data: any }>) => {
            let stepName = 'step' + actions.payload.step;
            // @ts-ignore
            state.formData[stepName] = actions.payload.data;
        },
        changeStep: (state, actions: PayloadAction<number>) => {
            state.formStep.currentStep = actions.payload
        },
        validateImageEkyc: (
            state,
            actions: PayloadAction<{
                file: any,
                status: 'idle' | 'disabled' | 'pass' | 'fail' | 'loading',
                message: string,
                type: 'face' | 'idFront' | 'idBack'
            }>
        ) => {
            //Update current type data
            let payload = actions.payload
            let ekycData = {
                image: payload.file,
                status: payload.status,
                message: payload.message
            }
            state.formData.step2[payload.type] = ekycData

            //Enable next input
            if (payload.status == 'pass') {
                switch (payload.type) {
                    case 'face':
                        state.formData.step2.idFront.status = 'idle'
                        break;
                    case 'idFront':
                        state.formData.step2.idBack.status = 'idle'
                        break;
                    case 'idBack':
                        state.formData.step2.faceMatching.status = 'idle'
                        break;
                    default:
                        break;
                }
            }
        },
        faceMatchingEkyc: (
            state,
            actions: PayloadAction<{
                status: 'idle' | 'disabled' | 'pass' | 'fail' | 'loading',
                message: string,
                information?: any
            }>
        ) => {
            let payload = actions.payload
            state.formData.step2.faceMatching = {
                status: payload.status,
                message: payload.message,
                idData: payload.information ?? {}
            }
        }
    },
});

export const {setInititalData,validateImageEkyc, faceMatchingEkyc, changeStep, updateFormData} =
    upgradCoSignerFormSlice.actions;
export default upgradCoSignerFormSlice;
